import './style.sass';

import React from 'react';

const TeamCaseItem = ({ item }) => {
    return (
        <div className="team-case-item">
            {item.members.map((members, index) => (
                <div key={index} className="team-case-item__wrapper">
                    {members.position ? (
                        <div className="team-case-item__wrapper-member">
                            <div className="team-case-item__wrapper-name">{members.name}</div>
                            <div className="team-case-item__wrapper-position">
                                {members.position}
                            </div>
                        </div>
                    ) : (
                        <div className="team-case-item__wrapper-member">
                            <div className="team-case-item__wrapper-name">{members.name}</div>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default TeamCaseItem;
